// ############################################################
// Copyright (C) 2021 by Gamify Software Inc - All Rights Reserved
// You may NOT distribute or modify this code without the expressed
// written consent of Gamify Software Inc.
// #############################################################
//
// SelectFromList
//

import React, { useState, useEffect } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import gql from 'graphql-tag';
import { API } from 'aws-amplify';

export default function SelectStage(props) {
  const [itemList, setItemList] = useState([]);

  async function fetchStages(_categoryID) {
    let categoryID = _categoryID;
    if (_categoryID === 'default') {
      const getDefaultCategoryId = gql`
        query MyQuery($orgID: ID!) {
          listStageCategorys(filter: { orgID: { eq: $orgID } }) {
            items {
              id
            }
          }
        }
      `;
      const getDefaultCategoryIdRes = await API.graphql({
        query: getDefaultCategoryId,
        variables: { orgID: global.me.orgID },
      });
      // console.log('getDefaultCategoryIdRes: ', getDefaultCategoryIdRes);

      if (getDefaultCategoryIdRes.data.listStageCategorys.items.length > 0) {
        categoryID =
          getDefaultCategoryIdRes.data.listStageCategorys.items[0].id;
      }
    }

    let myQuery;
    if (categoryID !== undefined) {
      myQuery = gql`
        query MyQuery($categoryID: ID!) {
          listStageByCategorySequence(
            categoryID: $categoryID
            filter: { isDeleted: { eq: false } }
            limit: 10000
          ) {
            items {
              id
              sequence
              title
              flexAttributes
              description
            }
          }
        }
      `;
    } else {
      myQuery = gql`
        query MyQuery($orgID: ID!) {
          listStages(
            filter: { orgID: { eq: $orgID }, isDeleted: { eq: false } }
            limit: 10000
          ) {
            items {
              id
              sequence
              title
              flexAttributes
              description
            }
          }
        }
      `;
    }

    const getStageRes = await API.graphql({
      query: myQuery,
      variables: { orgID: global.me.orgID, categoryID },
    });
    // console.log('getStageRes', getStageRes);
    let stages;
    if (categoryID !== undefined) {
      stages = getStageRes.data.listStageByCategorySequence.items;
    } else {
      stages = getStageRes.data.listStages.items;
    }

    // LOG.debug ("KPIs",KPIs);
    const assigneeList = [];
    if (props.activeOption) {
      assigneeList[assigneeList.length] = {
        label: '- Active Only',
        id: 'active',
        value: 'active',
      };
    }
    if (props.allOption) {
      assigneeList[assigneeList.length] = {
        label: '- All',
        id: 'all',
        value: 'all',
      };
    }

    let minSequence;
    if (props.minSequence !== undefined) {
      minSequence = props.minSequence;
    } else if (props.ignoreNoDealStages) {
      minSequence = 1;
    } else {
      minSequence = -1000;
    }
    for (const stage of stages) {
      // LOG.debug ("stage: ", stage);
      if (stage.sequence >= minSequence) {
        //
        //  Omit KPI's (dealstages) with the sequence <= 0 if props.ignoreNoDealStages is true
        //
        // LOG.debug ("stage.id: ", stage.id + " == props.value: " + props.value + "?")
        // if ( stage.id == props.value ) {
        //   //LOG.debug ("YES: ", stage.title)
        //   setName ( stage.title );
        // }
        assigneeList[assigneeList.length] = {
          id: stage.id,
          name: stage.title,
          value: stage.id,
          label: stage.title,
          display: stage.title,
          config: stage.flexAttributes,
          categoryID,
          sequence: stage.sequence,
        };
      }
    }

    const sortedAssigneeList = assigneeList.sort((a, b) => {
      if (a.sequence < b.sequence) return -1;
      if (a.sequence > b.sequence) return 1;
      return 0;
    });
    // LOG.debug ("sortedAssigneeList: ", sortedAssigneeList);
    setItemList(sortedAssigneeList);
  }

  useEffect(() => {
    fetchStages(props.categoryID);
  }, []);

  let itemLabel = '';
  for (const item of itemList) {
    if (item.id === props.value) {
      itemLabel = item.label;
      break;
    }
  }

  return (
    <Box className={props.className}>
      <>
        {itemList.length > 0 && (
          <Autocomplete
            classes={{ inputRoot: 'scorecard-dropdown-box' }}
            sx={{ width: 270 }}
            onChange={(event, val) => {
              props.fieldSetter(val.id, val.label);
            }}
            options={itemList}
            defaultValue={itemLabel}
            renderInput={(params) => <TextField {...params} />}
          />
        )}
      </>
    </Box>
  );
}
